import React from 'react';
import {TranslationContext} from "../translations/context";

const LocationPopup = (props) => {
    const {t} = React.useContext(TranslationContext);

    return <div style={{width: '300px'}}>
        {props.locations.map(location => <div onClick={() => window.location.href = location.booking_url}>
            <figure className="image is-3by2">
                <img src={location.photo_url} alt={`${t('station')} ${location.name}`}/>
            </figure>
            <h4>{location.name}</h4>
            <p>
                <i className="fa fa-map-marker" aria-hidden="true" />{' '}
                {location.locality}{' '}
                <i className="fa fa-bicycle" aria-hidden="true" />{' '}
                {location.ressource_count} {t('bikes')}
            </p>
            <button className="button is-fullwidth is-success">{t('book_now')}</button>
        </div>)}
    </div>
};

export default LocationPopup;
